module.exports = __webpack_public_path__ + "static/media/image006.2870d96a.jpg";